const autoNgTemplateLoaderTemplate1 = require('./accessViewerDatatable.html');

angular.module('portainer.app').component('accessViewerDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    tableKey: '@',
    orderBy: '@',
    dataset: '<',
  },
});
